import { render, staticRenderFns } from "./HomeSectionLightPollution.vue?vue&type=template&id=7af2b842&scoped=true&"
import script from "./HomeSectionLightPollution.vue?vue&type=script&lang=ts&"
export * from "./HomeSectionLightPollution.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af2b842",
  null
  
)

export default component.exports